var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.preloader),expression:"preloader"}],staticClass:"preloader",staticStyle:{"padding":"15%"}},[_c('img',{staticClass:"preloader1",attrs:{"src":require("../assets/image/carregando/aguarde-7.gif"),"width":"106","height":"106","alt":"Carregando..."}})])
}
var staticRenderFns = []

export { render, staticRenderFns }